import React from 'react'
import { useTheme } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import parse from 'html-react-parser'
import { styled } from '@mui/system'

const CustomDialogContent = styled(DialogContent)`
  /* Hide scrollbar for Chrome, Safari, and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge, and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */

  /* Make the content scrollable */
  overflow-y: auto;
`;

const CustomDialog = (props) => {
  const { open, onClose } = props
  const { dialogTitle, dialogBody } = props
  const { actionButtons } = props
  const { maxWidth, backgroundColor, closeIconColor } = props
  const defaultMaxWidth = 'sm'
  const theme = useTheme()
  
  const action_buttons = (actionButtons && actionButtons.length > 0) ? actionButtons : []

  const handleDialogClose = () => {
    onClose()
  }
  
  return (
    <Dialog 
      open={open} 
      onClose={handleDialogClose} 
      scroll='paper' 
      maxWidth={maxWidth ? maxWidth : defaultMaxWidth} 
      fullWidth={true}
      PaperProps={{
        style: {
            backgroundColor: backgroundColor ? backgroundColor : theme.palette.background.paper,
          },
      }}
    >
      <DialogTitle sx={ (dialogTitle && dialogTitle.sx) ? { ...dialogTitle.sx } : undefined }>
        { dialogTitle ? dialogTitle.title : parse('&nbsp;') }
        <IconButton
          onClick={handleDialogClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: closeIconColor ? closeIconColor : undefined,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <CustomDialogContent>
        {
          dialogBody &&
          <DialogContentText sx={{ ...dialogBody.sx }}>
            { dialogBody.text ? parse(dialogBody.text) : '' }
          </DialogContentText>
        }        
        {props.children}
      </CustomDialogContent>
      <DialogActions>
        {
          action_buttons.map((btn, index) => {
            return (
              <Button
                key={index}
                disabled={Object.keys(btn).indexOf('disabled') !== -1 ? btn.disabled : false} 
                onClick={btn.onClick}
                variant={btn.variant ? btn.variant : "text"}
                size={btn.size ? btn.size : "large"}
                sx={{ ...btn.sx }}
              >
                {btn.title}
              </Button>
            )
          })
        }
      </DialogActions>
    </Dialog>
  )
}

export default CustomDialog